import React from "react";
import ContentLoader from "react-content-loader";

const DebtResultsLoader = () => (
  <ContentLoader
    speed={2}
    width={500}
    height={130}
    viewBox="0 0 500 130"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="20" rx="4" ry="4" width="100" height="16" />
    <rect x="0" y="60" rx="4" ry="4" width="200" height="8" />
    <rect x="400" y="60" rx="4" ry="4" width="50" height="8" />
    <rect x="0" y="90" rx="4" ry="4" width="200" height="8" />
    <rect x="400" y="90" rx="4" ry="4" width="50" height="8" />
    <rect x="0" y="120" rx="4" ry="4" width="100" height="16" />
    <rect x="0" y="160" rx="4" ry="4" width="200" height="8" />
    <rect x="400" y="160" rx="4" ry="4" width="50" height="8" />
    <rect x="0" y="190" rx="4" ry="4" width="200" height="8" />
    <rect x="400" y="190" rx="4" ry="4" width="50" height="8" />
  </ContentLoader>
);

export default DebtResultsLoader;
